module.exports = __webpack_public_path__ + "fonts/be-vietnam-pro-v8-latin-500.baf3704.woff";